import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import "./GlobalNavigation.css";
import items from "./Navsearch.json";

import { IoPersonOutline } from "react-icons/io5";
import { FiBox, FiSettings, FiGrid } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";

import Fuse from "fuse.js";

const fuseOptions = {
  keys: ["navitem"],
  threshold: 0.35,
};

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeMainDropdown, setActiveMainDropdown] = useState(null);
  const [isSearchmenuOpen, setSearchmenuOpen] = useState(false);
  const [isProfilemenuOpen, setProfilemenuOpen] = useState(false);
  const [queryText, setqueryText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [popupVisible, setPopup] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 922px)").matches);
  const navRef = useRef(null);
  const menuRef = useRef(null);
  const searchRef = useRef(null);
  const searchInputRef = useRef(null);
  const profileRef = useRef(null);
  const location = useLocation();
  const overlayOpen = isMenuOpen || isSearchmenuOpen || isProfilemenuOpen;

  const closeAll = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
    setActiveMainDropdown(null);
    setSearchmenuOpen(false);
    setProfilemenuOpen(false);
  };

  useEffect(() => {
    const media = window.matchMedia("(max-width: 922px)");
    const change = () => { setIsMobile(media.matches); closeAll(); };
    media.addEventListener("change", change);
    return () => media.removeEventListener("change", change);
  }, []);

  // Route changes include browser Back/Forward. Never leave an invisible overlay
  // or a scroll lock behind after navigation.
  const previousRouteKey = useRef(location.key);
  useEffect(() => {
    // Closing overlays is necessary on navigation, not on initial mount.
    // An initial close can race with an immediately opened search panel.
    if (previousRouteKey.current === location.key) return;
    previousRouteKey.current = location.key;
    closeAll();
  }, [location.key]);
  useEffect(() => {
    if (!isMobile || !overlayOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previous; };
  }, [isMobile, overlayOpen]);

  useEffect(() => {
    if (isSearchmenuOpen) searchInputRef.current?.focus({ preventScroll: true });
  }, [isSearchmenuOpen]);

  useEffect(() => {
    const keydown = (event) => {
      if ((event.key === "s" || event.key === "S") && !event.target.closest('input, textarea, [contenteditable="true"]')) setPopup(true);
      if (event.key === "Escape") {
        const target = isSearchmenuOpen ? searchRef.current : isProfilemenuOpen ? profileRef.current
          : isMenuOpen ? menuRef.current : navRef.current?.querySelector(`[data-submenu="${activeMainDropdown}"]`);
        closeAll();
        setPopup(false);
        requestAnimationFrame(() => {
          target?.focus({ preventScroll: true });
          setActiveMainDropdown(null);
        });
      }
      if (event.key !== "Tab" || !(isMobile && overlayOpen)) return;
      const controls = [...navRef.current.querySelectorAll('a[href], button, input')].filter(el =>
        !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility === 'visible');
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
        event.preventDefault(); first?.focus();
      }
    };
    document.addEventListener("keydown", keydown);
    return () => document.removeEventListener("keydown", keydown);
  }, [isMobile, overlayOpen, isMenuOpen, isSearchmenuOpen, isProfilemenuOpen, activeMainDropdown]);

  const ToggleSearchmenu = () => {
    const next = !isSearchmenuOpen;
    closeAll(); setqueryText(""); setSearchmenuOpen(next);
  };
  const closeSearchMenu = () => { setSearchmenuOpen(false); requestAnimationFrame(() => searchRef.current?.focus({ preventScroll: true })); };
  const ToggleProfilemenu = () => {
    const next = !isProfilemenuOpen;
    closeAll(); setProfilemenuOpen(next);
  };
  const closeProfileMenu = () => { setProfilemenuOpen(false); requestAnimationFrame(() => profileRef.current?.focus({ preventScroll: true })); };
  const toggleMenu = () => {
    const next = !isMenuOpen;
    closeAll(); setIsMenuOpen(next);
  };
  const handleNavlinkClick = (event, id) => {
    if (!isMobile) return;
    event.preventDefault();
    setActiveDropdown(id);
  };
  const handleBackClick = () => {
    const trigger = navRef.current.querySelector(`[data-submenu="${activeDropdown}"]`);
    setActiveDropdown(null);
    // Visibility updates on the next render before restoring keyboard focus.
    requestAnimationFrame(() => trigger?.focus({ preventScroll: true }));
  };
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setqueryText(value);
    setSearchResults(new Fuse(items, fuseOptions).search(value));
  };
  const openmaindropdown = (id) => {
    if (!isMobile) { setActiveMainDropdown(id); setSearchmenuOpen(false); setProfilemenuOpen(false); }
  };
  const closemaindropdown = () => setActiveMainDropdown(null);
  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) closemaindropdown();
  };

  return (
    <nav ref={navRef} aria-label="Main navigation"
      className={`global-nav lokarpan-global-nav ${isSearchmenuOpen ? "nav-search-open" : ""} ${isProfilemenuOpen ? "nav-profile-open" : ""} ${isMobile && overlayOpen ? "nav-overlay-open" : ""} ${activeDropdown ? "nav-submenu-open" : ""}`}
      onClick={(event) => { if (event.target.closest('a[href]') && !event.defaultPrevented) closeAll(); }}
    >
      <div className="navbar">
        <div className="navbar-logo">
          <Link to="/" aria-label="Lokarpan home" onClick={closeAll}>
            <img
              src="https://res.cloudinary.com/digbzwlfx/image/upload/v1707625023/Frame_48098098_rag4wi.svg"
              className="lokarpan-logo"
              alt="Lokarpan"
            />
          </Link>
        </div>
        <button
          type="button"
          className={`nav-control nav-back ${activeDropdown !== null ? "active" : ""}`}
          aria-label="Back to main menu"
          onClick={handleBackClick}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path d="M12 2 L5 9 L12 16" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <ul
          id="navbar-mainmenu"
          inert={isMobile && !isMenuOpen ? "" : undefined}
          className={`navbar-links navbar-menu ${isMenuOpen ? "active" : ""}`}
        >
          <li className="navbar-item mobile-padding-left mobile-padding-top">
            <Link to="/">Home</Link>
          </li>
          <li
            className="navbar-item mobile-padding-left dropdown"
            onPointerEnter={(event) => { if (event.pointerType === "mouse") openmaindropdown("aboutDropdown"); }}
            onPointerLeave={(event) => { if (event.pointerType === "mouse") closemaindropdown(); }}
            onFocus={() => openmaindropdown("aboutDropdown")}
            onBlur={handleBlur}
          >
            <Link to="/about" data-submenu="aboutDropdown" aria-haspopup="true"
              aria-expanded={isMobile ? activeDropdown === "aboutDropdown" : activeMainDropdown === "aboutDropdown"}
              onClick={(event) => handleNavlinkClick(event, "aboutDropdown")}>
              About
            </Link>
            <div
              inert={(isMobile ? activeDropdown !== "aboutDropdown" || !isMenuOpen : activeMainDropdown !== "aboutDropdown") ? "" : undefined}
              className={`nav-submenu-panel ${
                activeDropdown === "aboutDropdown" ? "active" : ""
              } ${
                activeMainDropdown === "aboutDropdown" ? "desktopactive" : ""
              }`}
            >
              <div className="nav-submenu-content">
                <div className="nav-submenu-column">
                  <h1 className="nav-primary-heading">Explore About</h1>

                  <ul className="nav-primary-links">
                    <li>
                      <Link to="/about">Our Role</Link>
                    </li>
                    <li>
                      <Link to="/history">History</Link>
                    </li>
                    <li>
                      <Link to="/mission">Mission</Link>
                    </li>
                    <li>
                      <Link to="/leadership">Leadership</Link>
                    </li>
                    <li>
                      <Link to="/career">Careers</Link>
                    </li>
                    <li>
                      <Link to="/financials">Financials</Link>
                    </li>
                  </ul>
                </div>
                <div className="nav-submenu-column">
                  <h1 className="nav-secondary-heading">Quick Links</h1>
                  <ul className="nav-secondary-links">
                    {/* <li>
                      <Link to="/alumni">Alumni</Link>
                    </li> */}
                    <li>
                      <Link to="/contact-us">Contact</Link>
                    </li>
                    <li>
                      <a href="https://medium.com/lokarpan" target="_blank">
                        Blog
                      </a>
                    </li>
                    <li>
                      <button type="button" className="nav-subscribe-action" onClick={() => setPopup(true)}>
                        Subscribe
                      </button>
                    </li>
                    {popupVisible && (
                      <div className="popup-on">
                        <div className="popup-back"></div>
                        <div className="popup-in">
                          <div className="pop">
                            <h2>Get updates from Lokarpan.</h2>
                          </div>
                          <RxCross2
                            onClick={() => {
                              setPopup(false);
                            }}
                            className="x"
                          />
                          <div className="popup-text"
                          
          style={{alignItems:"center", display: "flex", flexDirection:"column"}}>
                            <p>
                              Join our vibrant community of engaged readers as
                              we deliver the latest updates, success stories,
                              and transformative initiatives aimed at empowering
                              rural education.
                            </p>
                            {/* <form action="">
                              <input type="text" placeholder="Email address" />
                              <button type="submit">Subscribe</button>
                            </form> */}


<iframe 
            src="https://embeds.beehiiv.com/111ea47e-dc16-433e-9855-2339e60d6f51?slim=true" 
            data-test-id="beehiiv-embed" 
            height="52" 
            scrolling="no" 
            style={{
              margin: "0", 
              borderRadius: "10px !important", 
              backgroundColor: "transparent",
              width: "70%"
            }}
            ></iframe>
                          </div>
                        </div>
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li
            className="navbar-item mobile-padding-left dropdown"
            onPointerEnter={(event) => { if (event.pointerType === "mouse") openmaindropdown("eduDropdown"); }}
            onPointerLeave={(event) => { if (event.pointerType === "mouse") closemaindropdown(); }}
            onFocus={() => openmaindropdown("eduDropdown")}
            onBlur={handleBlur}
          >
            <Link to="/approach" data-submenu="eduDropdown" aria-haspopup="true"
              aria-expanded={isMobile ? activeDropdown === "eduDropdown" : activeMainDropdown === "eduDropdown"}
              onClick={(event) => handleNavlinkClick(event, "eduDropdown")}>
              Education
            </Link>
            <div
              inert={(isMobile ? activeDropdown !== "eduDropdown" || !isMenuOpen : activeMainDropdown !== "eduDropdown") ? "" : undefined}
              className={`nav-submenu-panel ${
                activeDropdown === "eduDropdown" ? "active" : ""
              } ${activeMainDropdown === "eduDropdown" ? "desktopactive" : ""}`}
            >
              <div className="nav-submenu-content">
                <div className="nav-submenu-column">
                  <h1 className="nav-primary-heading">Explore Education</h1>
                  <ul className="nav-primary-links">
                    <li><Link to="/education">Overview</Link></li>
                    <li>
                      <Link to="/approach">Approach</Link>
                    </li>
                    <li>
                      <Link to="/digital-tool">Digital Tools</Link>
                    </li>
                    <li>
                      <Link to="/application">Application</Link>
                    </li>
                    <li>
                      <Link to="/podcasts">Podcast</Link>
                    </li>
                  </ul>
                </div>
                <div className="nav-submenu-column">
                  <h1 className="nav-secondary-heading">Quick Links</h1>
                  <ul className="nav-secondary-links">
                    <li>
                      <Link to="/impact">Impact</Link>
                    </li>
                    <li>
                      <Link to="/moonshots">Moonshots</Link>
                    </li>
                    <li>
                      <Link to="/being-a-volunteer">
                        {/*  need to update to in Link  */}
                        Volunteer
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li className="navbar-item mobile-padding-left">
            <Link to="/fellowship">Fellowship</Link>
          </li>
          <li className="navbar-item mobile-padding-left">
            <Link
              to="/kith/overview"
              onClick={(e) => {
                toggleMenu(e);
              }}
            >
              Kith
            </Link>
          </li>
          <li
            className="navbar-item mobile-padding-left dropdown"
            onPointerEnter={(event) => { if (event.pointerType === "mouse") openmaindropdown("designDropdown"); }}
            onPointerLeave={(event) => { if (event.pointerType === "mouse") closemaindropdown(); }}
            onFocus={() => openmaindropdown("designDropdown")}
            onBlur={handleBlur}
          >
            <Link to="/design" data-submenu="designDropdown" aria-haspopup="true"
              aria-expanded={isMobile ? activeDropdown === "designDropdown" : activeMainDropdown === "designDropdown"}
              onClick={(event) => handleNavlinkClick(event, "designDropdown")}>
              Design
            </Link>
            <div
              inert={(isMobile ? activeDropdown !== "designDropdown" || !isMenuOpen : activeMainDropdown !== "designDropdown") ? "" : undefined}
              className={`nav-submenu-panel ${
                activeDropdown === "designDropdown" ? "active" : ""
              } ${
                activeMainDropdown === "designDropdown" ? "desktopactive" : ""
              }`}
            >
              <div className="nav-submenu-content">
                <div className="nav-submenu-column">
                  <h1 className="nav-primary-heading">Explore Design</h1>
                  <ul className="nav-primary-links">
                    <li><Link to="/design">Overview</Link></li>
                    <li>
                      <Link to="/design">About</Link>
                    </li>
                    <li>
                      <Link to="/designlist">Projects</Link>
                    </li>
                    <li>
                      <Link to="/guideline">Design Guidelines</Link>
                    </li>
                    <li>
                      <Link to="/about">Resources</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li className="navbar-item mobile-padding-left">
            <Link to="/health">Health</Link>
          </li>
          <li className="navbar-item mobile-padding-left">
            <Link to="/environment">Environment</Link>
          </li>
          <li className="navbar-item mobile-padding-left">
            <Link to="/livelihood">Livelihood</Link>
          </li>
          <li
            className="navbar-item mobile-padding-left dropdown"
            onPointerEnter={(event) => { if (event.pointerType === "mouse") openmaindropdown("supportDropdown"); }}
            onPointerLeave={(event) => { if (event.pointerType === "mouse") closemaindropdown(); }}
            onFocus={() => openmaindropdown("supportDropdown")}
            onBlur={handleBlur}
          >
            <Link to="/ways-to-give" data-submenu="supportDropdown" aria-haspopup="true"
              aria-expanded={isMobile ? activeDropdown === "supportDropdown" : activeMainDropdown === "supportDropdown"}
              onClick={(event) => handleNavlinkClick(event, "supportDropdown")}>
              Support
            </Link>
            <div
              inert={(isMobile ? activeDropdown !== "supportDropdown" || !isMenuOpen : activeMainDropdown !== "supportDropdown") ? "" : undefined}
              className={`nav-submenu-panel ${
                activeDropdown === "supportDropdown" ? "active" : ""
              } ${
                activeMainDropdown === "supportDropdown" ? "desktopactive" : ""
              }`}
            >
              <div className="nav-submenu-content">
                <div className="nav-submenu-column">
                  <h1 className="nav-primary-heading">Explore Donate</h1>
                  <ul className="nav-primary-links">
                    <li>
                      <Link to="/ways-to-give">Ways to Give</Link>
                    </li>
                    <li>
                      <Link to="/being-a-volunteer">Being a Volunteer</Link>
                    </li>
                    <li>
                      <Link to="/our-supporter">Our Supporters</Link>
                    </li>
                    <li>
                      <Link to="/why-donate">Why Donate</Link>
                    </li>
                    <li>
                      <Link to="/donate">Donate Now</Link>
                    </li>
                  </ul>
                </div>
                <div className="nav-submenu-column">
                  <h1 className="nav-secondary-heading">Quick Links</h1>
                  <ul className="nav-secondary-links">
                    <li>
                      <Link to="/financials">Financials</Link>
                    </li>
                    <li>
                      <Link to="/fellowship">Apply for Fellowship</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul className="navbar-links navbar-icons">
          <li
            className="navbar-item dropdown navbar-icon nav-search"
          >
            <button ref={searchRef} type="button" className="nav-control nav-search-trigger" aria-label="Search Lokarpan" aria-expanded={isSearchmenuOpen} onClick={ToggleSearchmenu}>
              <svg className="navbar-icon-inner nav-apple-search-icon" aria-hidden="true" viewBox="0 0 20 20" fill="none"><circle cx="8.45" cy="8.45" r="5.7" stroke="currentColor" strokeWidth="1.25"/><path d="m12.7 12.7 4.3 4.3" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round"/></svg>
            </button>
            <div
              inert={!isSearchmenuOpen ? "" : undefined}
              className={`nav-overlay-panel search-panel ${
                isSearchmenuOpen ? "active" : ""
              }`}
            >
              <div className="nav-overlay-inner nav-search-content">
                <div className="nav-searchbar">
                  <button
                    type="button"
                    className="nav-control nav-search-close"
                    aria-label="Close search"
                    onClick={closeSearchMenu}
                  >
                    <span className="nav-toggle-glyph is-close" aria-hidden="true"><span /><span /></span>
                  </button>
                  <div className={`nav-form ${queryText ? "has-query" : ""}`}>
                    <svg className="react-icon margin0 size-80 nav-apple-search-icon" aria-hidden="true" viewBox="0 0 20 20" fill="none"><circle cx="8.45" cy="8.45" r="5.7" stroke="currentColor" strokeWidth="1.25"/><path d="m12.7 12.7 4.3 4.3" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round"/></svg>
                    <input
                      className="nav-form-control text-input"
                      type="search"
                      aria-label="Search Lokarpan"
                      placeholder="Search"
                      value={queryText}
                      onChange={handleSearchChange}
                      ref={searchInputRef}
                    />
                    {queryText && (
                      <button type="button" className="nav-clear-search" aria-label="Clear search" onClick={() => {
                        setqueryText(""); setSearchResults([]); searchInputRef.current?.focus();
                      }}><RxCross2 aria-hidden="true" /></button>
                    )}
                  </div>
                  <div className="search-quick-links">
                    {queryText === "" ? (
                      <div>
                        <h4>Quick Links</h4>
                        <ul className="nav-secondary-links">
                          <li>
                            <Link to="/about">Our Role</Link>
                          </li>
                          <li>
                            <Link to="/history">History</Link>
                          </li>
                          <li>
                            <Link to="/fellowship">Fellowship</Link>
                          </li>
                          <li>
                            <Link to="/being-a-volunteer">
                              Being a Volunteer
                            </Link>
                          </li>
                          <li>
                            <Link to="/donate">Donate</Link>
                          </li>
                          <li>
                            <Link to="/contact-us">Contact</Link>
                          </li>
                        </ul>
                      </div>
                    ) : searchResults.length === 0 ? (
                      "No results found"
                    ) : (
                      <>
                        <h4>Suggested Links</h4>
                        <ul>
                          {searchResults.map(({ item }) => (
                            <li key={item.Link}>
                              <Link to={item.Link} onClick={() => setSearchmenuOpen(false)}>
                                {item.navitem}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            className="navbar-item dropdown navbar-icon nav-search"
          >
            <button ref={profileRef} type="button" className="nav-control nav-profile-trigger" aria-label="Open profile" aria-expanded={isProfilemenuOpen} onClick={ToggleProfilemenu}>
              <IoPersonOutline className="navbar-icon-inner" aria-hidden="true" />
            </button>
            <div
              inert={!isProfilemenuOpen ? "" : undefined}
              className={`nav-overlay-panel profile-panel ${
                isProfilemenuOpen ? "active" : ""
              }`}
            >
              <div className="nav-overlay-inner">
                <button type="button" className="nav-control nav-search-close" aria-label="Close profile" onClick={closeProfileMenu}>
                  <span className="nav-toggle-glyph is-close" aria-hidden="true"><span /><span /></span>
                </button>
                <div className="nav-profile nav-bag-content">
                  <h2 className="nav-bag-heading">Get Involved</h2>
                  <p className="nav-bag-message"><Link to="/newsletter" onClick={closeProfileMenu}>Subscribe</Link> to read more about our impact.</p>
                  <h3 className="nav-bag-section">My Profile</h3>
                  <ul className="nav-bag-links">
                    <li><a href="https://horizon.lokarpan.com" target="_blank" rel="noopener noreferrer"><FiGrid aria-hidden="true" />Horizon</a></li>
                    <li><a href="https://lokarpan.com/admin" target="_blank" rel="noopener noreferrer"><FiSettings aria-hidden="true" />Admin</a></li>
                    <li><span aria-disabled="true"><FiBox aria-hidden="true" />InsightX</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li className="navbar-item hamburger-item">
            <button
              type="button"
              ref={menuRef}
              className={`hamburger nav-control ${isMenuOpen ? "active" : ""}`}
              aria-label={isMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={isMenuOpen}
              aria-controls="navbar-mainmenu"
              onClick={toggleMenu}
            >
              <span className={`nav-toggle-glyph ${isMenuOpen ? "is-close" : ""}`} aria-hidden="true"><span /><span /></span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
